import { Error } from '../common/types';

export interface OrganizationState {
  readonly organizationById: Record<string, Organization>;
  readonly organizationFeatures: OrganizationFeature[];
  readonly isLoading: Record<string, boolean>;
  readonly error: Record<string, Error>;
  readonly success: Record<string, boolean>;
  readonly selectedOrganizationId?: Nullable<string>;
}

export interface Organization {
  id: string;
  name: string;
  logoImageUrl: string;
  created: string;
  modified: string;
  timezone?: string;
  locationCity?: string;
  locationRegion?: string;
  accountType?: string;
}

export interface OrganizationLocation {
  timezone?: string;
  locationCity?: string;
  locationRegion?: string;
}

export interface NewOrganizationRequest {
  name: string;
  logoImageUrl: string;
  email: string;
  givenNames: string;
  familyName: string;
}

export interface OrganizationFeature {
  organizationId: string;
  featureId: string;
  enabled: boolean;
}

// Feature ID constants
export const FEATURE_GAMIFICATION_EMAIL = '00000000-0000-0000-0000-000000000001';
export const FEATURE_DISABLE_EMAIL_SUMMARIES = '00000000-0000-0000-0000-000000000002';
